import ParcelSelectContainer, {
  ParcelSelectFieldContainer,
} from '~/containers/ParcelSelectContainer/ParcelSelect.container';

export { ParcelSelectFieldContainer };

export default ParcelSelectContainer;
